export default __webpack_public_path__ + "static/media/undeadminionblightedone.e28029ec.png";